import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { IS_PRERENDERING } from './utils/config'; // Import the centralized flag

let i18nChain = i18n.use(HttpApi);

if (!IS_PRERENDERING) {
  i18nChain = i18nChain.use(LanguageDetector);
}

i18nChain.use(initReactI18next).init({
  // The 'resources' option is removed, as translations are now loaded via http
  fallbackLng: 'en', // Use English if detected language is not available
  load: 'languageOnly', // Use only language code (e.g., 'en' instead of 'en-US')
  debug: process.env.NODE_ENV === 'development', // Enable debug logs in development
  interpolation: {
    escapeValue: false, // React already protects from xss
  },
  // Default namespace
  ns: ['translation'],
  defaultNS: 'translation',
  detection: {
    // For prerendering, only use the path. For live, use path and cookie.
    order: IS_PRERENDERING ? ['path'] : ['path', 'cookie'],
    lookupFromPathIndex: 0, // Look at the first segment of the path
    caches: [], // Disable caching here, as our hook manages the cookie
  },
  // Configuration for i18next-http-backend
  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
  },
});

export default i18n;
